import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { CpCompareSidebarCardsService } from '@pages/control-page/control-page-main/control-page-compare/cp-compare-sidebar/cp-compare-sidebar-cards.service';
import { combineLatest, map } from 'rxjs';

@Component({
  selector: 'app-cp-compare-home-electricity',
  templateUrl: './cp-compare-home-electricity.component.html',
  styleUrls: ['./cp-compare-home-electricity.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpCompareHomeElectricityComponent {

  private measureCards$ = this.compareSidebarCardsService.measureCards$.pipe(
    map((measureCards) => measureCards.filter(measureCard => ElectricityMeasureTypes.includes(measureCard.measureType)))
  );

  viewModel$ = combineLatest({
    measureCards: this.measureCards$,
  });

  constructor(
    private compareSidebarCardsService: CpCompareSidebarCardsService,
  ) {}

}

const ElectricityMeasureTypes = [
  EnumMeasureTypes.SUM_ENERGY_BUY_FROM_GRID_BASE,
  EnumMeasureTypes.SUM_ENERGY_BUY_FROM_GRID_PRICE_BASE,
];